<h3>Cadastrar Usuário</h3>

<form #thisForm="ngForm" (ngSubmit)="submit()">
  <div class="card mt-3">
    <div class="card-header text-uppercase">Usuários</div>
    <div class="card-body">
      <div class="row mb-2" *ngIf="canCreateMaster()">
        <div class="col-12">
          <label>Usuário Distribuidor</label>
          <input
            (change)="getDistributorGroups()"
            type="checkbox"
            class="form-check-input"
            name="isDistributor"
            [(ngModel)]="model.isDistributor"
          />
        </div>
      </div>
      <div class="row mb-2" *ngIf="canCreateMaster() && !model.isDistributor">
        <div class="col-12">
          <label>Usuário Externo</label>
          <input
            type="checkbox"
            class="form-check-input"
            data-cy="isExternalUser"
            name="isExternalUser"
            [(ngModel)]="model.isExternalUser"
          />
        </div>
      </div>
      <div
        class="row mb-2"
        *ngIf="
          canCreateSubordinate() &&
          !canCreateMaster() &&
          !canCreateDistributor()
        "
      >
        <div class="col-12">
          <label>Gestora:</label>
          <p>{{ nomeGestora }}</p>
        </div>
      </div>
      <div
        class="row mb-2"
        *ngIf="
          model.isExternalUser &&
          canCreateMaster() &&
          this.model.isDistributor == false
        "
      >
        <div class="col-12" [class.has-error]="hasError('accountManager')">
          <label>Gestora</label>
          <ng-select
            bindLabel="document"
            bindValue="id"
            [(ngModel)]="model.accountManagerId"
            data-cy="accountManagerId"
            name="accountManagerId"
            notFoundText="Nenhuma gestora encontrada"
            placeholder="Gestora"
            [required]="model.isExternalUser"
          >
            <ng-option
              *ngFor="let accManager of accountManagers"
              [value]="accManager.id"
              >{{ accManager.document + " " + accManager.name }}</ng-option
            >
          </ng-select>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <label>Nome</label>
          <input
            type="text"
            class="form-control"
            name="name"
            data-cy="name"
            [(ngModel)]="model.name"
            placeholder="Nome"
            maxlength="70"
            required
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <label>E-mail</label>
          <input
            type="text"
            class="form-control"
            name="email"
            data-cy="email"
            [(ngModel)]="model.email"
            placeholder="E-mail"
            pattern="^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,20}$"
            maxlength="70"
            required
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12" [class.has-error]="hasError('userDocument')">
          <label>CPF</label>
          <input
            type="text"
            class="form-control"
            name="userDocument"
            data-cy="userDocument"
            [(ngModel)]="model.userDocument"
            placeholder="CPF"
            required
            [textMask]="{
              mask: validator.documentPhysicalPersonMask,
              guide: false
            }"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <label>Login</label>
          <input
            type="text"
            class="form-control"
            name="userName"
            data-cy="login"
            [(ngModel)]="model.userName"
            placeholder="Login"
            maxlength="25"
            required
            [readonly]="isReadonly()"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <label>Grupos</label>
          <ng-select
            [items]="groups"
            [multiple]="true"
            bindLabel="name"
            [closeOnSelect]="false"
            bindValue="id"
            data-cy="groups"
            [(ngModel)]="model.groups"
            name="groups"
            placeholder="Grupos"
            notFoundText="Nenhum grupo encontrado"
          >
            <ng-template
              ng-option-tmp
              let-item="item"
              let-item$="item$"
              let-index="index"
            >
              <input
                id="item-{{ index }}"
                type="checkbox"
                [ngModel]="item$.selected"
                name="groupSel-{{ index }}"
              />
              {{ item.name }}
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div
        class="row mb-2"
        *ngIf="canCreateDistributor() || model.isDistributor"
      >
        <div class="col-12">
          <label>Fundos Investidos</label>
          <ng-select
            [items]="investedFund"
            [multiple]="true"
            bindLabel="name"
            [closeOnSelect]="false"
            bindValue="id"
            data-cy="investedFund"
            [(ngModel)]="model.investedFund"
            name="investedFund"
            placeholder="Fundos Investidos"
            notFoundText="Nenhum fundo encontrado"
          >
            <ng-template
              ng-option-tmp
              let-item="item"
              let-item$="item$"
              let-index="index"
            >
              <input
                id="item-{{ index }}"
                type="checkbox"
                [ngModel]="item$.selected"
                name="groupSel-{{ index }}"
              />
              {{ item.name }}
            </ng-template>
          </ng-select>
        </div>
      </div>
      <div
        class="row mb-2"
        *ngIf="
          model.isExternalUser && canCreateMaster() && !model.isDistributor
        "
      >
        <div class="col-12">
          <label>Usuário Master</label>
          <input
            type="checkbox"
            id="isMaster"
            class="form-check-input"
            data-cy="isMaster"
            name="isMaster"
            [(ngModel)]="model.isMaster"
            [disabled]="isReadonly()"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <label>Bloqueio Até</label>
          <input
            type="text"
            class="form-control"
            name="lockoutEndDateUtc"
            data-cy="lockoutEndDateUtc"
            [(ngModel)]="model.lockoutEndDateUtc"
            [textMask]="{ mask: validator.dateMask, guide: false }"
            placeholder="Bloqueio Até"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-2">
          <label>Validade da Senha</label>
          <input
            type="text"
            class="form-control"
            name="passwordExpirationDate"
            data-cy="passwordExpirationDate"
            [(ngModel)]="model.passwordExpirationDate"
            required
            disabled
          />
        </div>
        <div class="col-2">
          <input
            *ngIf="showResetPassword()"
            style="margin-top: 24px"
            type="button"
            value="Resetar Senha"
            data-cy="submit"
            class="btn btn-primary me-2"
            appDebounceClick
            (debounceClick)="send()"
            [debounceTime]="200"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <label>Bloqueado</label>
          <input
            class="form-check-input"
            data-cy="lockoutEnabled"
            id="lockoutEnabled"
            name="lockoutEnabled"
            [(ngModel)]="model.lockoutEnabled"
            type="checkbox"
          />
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-12">
          <label>Ativo</label>
          <input
            class="form-check-input"
            id="active"
            name="active"
            data-cy="active"
            [(ngModel)]="model.active"
            type="checkbox"
          />
        </div>
      </div>
      <div *ngIf="model.id">
        <input
          type="button"
          value="Resetar MFA"
          data-cy="reset2FA"
          class="btn btn-primary me-2"
          appDebounceClick
          (debounceClick)="reset2FA()"
          [debounceTime]="200"
        />
      </div>
    </div>
  </div>

  <div class="actions">
    <input
      type="button"
      value="Salvar"
      data-cy="submit"
      class="btn btn-primary me-2"
      appDebounceClick
      (debounceClick)="submit()"
      [debounceTime]="200"
    />
  </div>
</form>
